import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Error } from '../models';
import { errorActions } from '../actions';

export const errorAdapter: EntityAdapter<Error> = createEntityAdapter<Error>({
  selectId: (item: Error) => item.id,
  sortComparer: false
});

export interface State extends EntityState<Error> {}

export const INIT_STATE: State = errorAdapter.getInitialState();

export function reducer(state = INIT_STATE, action: errorActions.All) {
  switch (action.type) {
    case errorActions.ADD_ERROR: {
      return errorAdapter.addOne(action.payload, state);
    }
    case errorActions.REMOVE_ERROR: {
      return errorAdapter.removeOne(action.payload.id, state);
    }
    case errorActions.REMOVE_ERROR_BY_ID: {
      return errorAdapter.removeOne(action.payload, state);
    }
    case errorActions.CLEAR_ALL_ERRORS: {
      return errorAdapter.removeAll(state);
    }
    default: {
      return state;
    }
  }
}
